<template>
	<div v-if="this.$checkStatusResponse(this.status)">
		<section>
			<div class="container col-lg-11 mt-5">
				<card noBody type="secondary" style="margin-top: 150px;">
					<div class="container">
						<div class="pl-0">
							<div class="row row-grid align-items">
								<div class="col-sm-2">
									<h3 class="text-dark text-center mt-0"><strong>Address</strong></h3>
								</div>
								<div class="col-sm-8">
									<h6 class="text-muted text-truncate mt-4 mb-4 py-2">{{this.$route.params.address}}</h6>
								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items">
					<div class="container">
						<div class="row row-grid align-items">
							<div class="col-md-6">
								<hr class="mt-3 mb-3">
								<div class="row row-grid align-items">
									<div class="col-md-6">
										<p class="text-dark mb-0 text-left pl-4">AHT Balance:</p>
									</div>
									<div class="col-md-6">
										<p class="text-left mb-0 text-muted">{{this.$globalConverter(status)}}</p>
									</div>
								</div>
								<hr class="mt-3 mb-3">
							</div>
							<div class="col-md-6">
								<hr class="mt-3 mb-3">
								<div class="row row-grid align-items">
									<div class="col-md-6">
										<p class="text-dark mb-0 text-left pl-4">No Of Transactions:</p>
									</div>
									<div class="col-md-6">
										<p class="text-left mb-0 text-muted">{{count}}</p>
									</div>
								</div>
								<hr class="mt-3 mb-3">
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items">
					<card type="teal" noBody class="border-0">
						<div class="pl-0">
							<div class="container">
								<div class="row row-grid align-items">
									<div class="col-sm-6">
										<img src="../assets/icons/bars.png" alt="" style="width: 15px; padding-top: 6px;" align="left">
										<h6 class="text-white mb-1 mt-1 text-uppercase text-left px-4">Transactions</h6>
									</div>
								</div>
							</div>
						</div>
					</card>
				</div>
				<div class="order-lg-2 align-items mt-3 mb-5">
					<card type="secondary">
						<div class="row row-grid align-items">
							<div class="col">
								<h6 class="text-dark text-left pl-4 mb-0"><strong>Latest {{transactions.length}} txns</strong></h6>
							</div>
						</div>
						<hr class="mt-3 mb-3">
						<div class="row">
							<div class="col-sm-2">
								<h6 class="text-dark text-left mb-0 pl-4"><strong>TxHash</strong></h6>
							</div>
							<div class="col-sm-1">
								<h6 class="text-dark text-left mb-0"><strong>Block</strong></h6>
							</div>
							<div class="col-sm-1">
								<h6 class="text-dark text-left mb-0"><strong>Age</strong></h6>
							</div>
							<div class="col-sm-3">
								<h6 class="text-dark text-left mb-0"><strong>From</strong></h6>
							</div>
							<div class="col-sm-1">
								<h6 class="text-dark text-left mb-0"><strong></strong></h6>
							</div>
							<div class="col-sm-3">
								<h6 class="text-dark text-left mb-0"><strong>To</strong></h6>
							</div>
							<div class="col-sm-1">
								<h6 class="text-dark text-left mb-0"><strong>Value</strong></h6>
							</div>
						</div>
						<hr class="mb-3 mt-3">
						<div class="row row-grid align-items" v-for="field in transactions" :key="field._id + field.hash">
							<div class="col-sm-2">
								<router-link :to="'/tx/' + field.hash">
									<p class="text-info mb-0 text-truncate text-left">{{field.hash}}</p>
								</router-link>
							</div>
							<div class="col-sm-1">
								<router-link :to="'/block/' + field.block">
									<p class="text-info mb-0 text-truncate text-left">{{field.block}}</p>
								</router-link>
							</div>
							<div class="col-sm-1">
								<p class="text-dark text-truncate mb-0">{{field.receiptDate | moment('from', 'now')}}</p>
							</div>
							<div class="col-sm-3" v-if="isSameAddress(field.from)">
								<p class="text-truncate text-dark mb-0">{{field.from}}</p>
							</div>
							<div class="col-sm-3" v-else>
								<router-link :to="'/address/' + field.from">
									<p class="text-truncate text-info mb-0">{{field.from}}</p>
								</router-link>
							</div>
							<div class="col-sm-1" v-if="isSameAddress(field.from)">
								<base-button outline type="warning" align class="btn-sm text-truncate" block disabled>Out</base-button>
							</div>
							<div class="col-sm-1" v-else>
								<base-button outline type="success" align class="btn-sm text-truncate" disabled>In</base-button>
							</div>
							<div class="col-sm-3" v-if="isSameAddress(field.to)">
								<p class="text-truncate text-dark mb-0">{{field.to}}</p>
							</div>
							<div class="col-sm-3" v-else="">
								<router-link :to="'/address/' + field.to">
									<p class="text-truncate text-info mb-0 text-left">{{field.to}}</p>
								</router-link>
							</div>
							<div class="col-12 col-sm-1">
								<p class="text-truncate text-dark mb-0 text-left">{{$globalConverter(field.value)}}</p>
							</div>
							<div class="col-sm-auto">
								<hr class="mb-0 mt-0">
							</div>
						</div>
					</card>
				</div>
			</div>
		</section>
	</div>
	<div v-else>
		<section>
			<div class="container col-lg-11 mt-5">
				<card noBody type="secondary" style="margin-top: 150px;">
					<div class="container">
						<div class="pl-0">
							<div class="row row-grid align-items">
								<div class="col-sm-2">
									<h3 class="text-dark text-left mt-4 mb-4"><strong>Address</strong></h3>
								</div>
								<div class="col-sm-10">
									<h6 class="text-muted text-left float-center text-truncate">{{this.$route.params.address}}</h6>
								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items">
					<div class="container">
						<div class="row row-grid align-items">
							<div class="col-md-6">
								<hr class="mt-3 mb-3">
								<div class="row row-grid align-items">
									<div class="col-md-6">
										<p class="text-dark mb-0 text-left pl-4">AHT Balance:</p>
									</div>
									<div class="col-md-6">
										<p class="text-left mb-0 text-muted">0</p>
									</div>
								</div>
								<hr class="mt-3 mb-3">
							</div>
							<div class="col-md-6">
								<hr class="mt-3 mb-3">
								<div class="row row-grid align-items">
									<div class="col-md-6">
										<p class="text-dark mb-0 text-left pl-4">No Of Transactions:</p>
									</div>
									<div class="col-md-6">
										<p class="text-left mb-0 text-muted">{{transactions.length}}</p>
									</div>
								</div>
								<hr class="mt-3 mb-3">
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items">
					<card type="teal" noBody class="border-0">
						<div class="pl-0">
							<div class="container">
								<div class="row row-grid align-items">
									<div class="col-sm-6">
										<img src="../assets/icons/bars.png" alt="" style="width: 15px; padding-top: 6px;" align="left">
										<h6 class="text-white mb-1 mt-1 text-uppercase text-left px-4">Transactions</h6>
									</div>
								</div>
							</div>
						</div>
					</card>
				</div>
				<div class="order-lg-2 align-items mt-3 mb-5">
					<card type="secondary">
						<h6 class="text-warning text-center">There are not marching entries</h6>
					</card>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
  data () {
    return {
      transactions: [],
      status: {},
      count: {}
    }
  },
  methods: {
    isSameAddress (address) {
      if (this.$route.params.address === address) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.$http
      .get('get-transactions/' + this.$route.params.address)
      .then(response => {
        return response.json()
      })
      .then(data => {
        for (let i = 0; i < data.result.length; i++) {
          this.transactions.push(data.result[i])
        }
        this.status = data.balance
        this.count = data.count
      }, response => {
        this.status = response.status
      })
  },
  watch: {
    '$route.params.address': function () {
      this.transactions = []
      this.status = {}
      this.$http
        .get('get-transactions/' + this.$route.params.address)
        .then(response => {
          return response.json()
        })
        .then(data => {
          for (let i = 0; i < data.result.length; i++) {
            this.transactions.push(data.result[i])
          }
          this.status = data.balance
          this.count = data.count
        }, response => {
          this.status = response.status
        })
    }
  }
}
</script>

<style>
</style>
